module.exports = __webpack_public_path__ + "static/media/logo.8100ece2.svg";